<div style="display: flex; justify-content: space-between; align-items: center;">
  <h3 style="margin: 0;">{{(data.isNew? 'New ' : '') + 'Model File for ' + data.metadataLabel}}</h3>
  @if (!data.isNew) {
    <button mat-icon-button (click)="onCancel()" aria-label="Close dialog">
      <mat-icon class="icon-color-fix-orange">close</mat-icon>
    </button>
  }
</div>
<br />
<form [formGroup]="editForm">
  @if (!data.isNew) {
    <div style="display: flex; gap: 10px;">
      <mat-form-field appearance="outline" style="flex: 1" floatLabel="always">
        <mat-label>Created by</mat-label>
        <input matInput [value]="editForm.value.createdByUser" readonly style="cursor: default"/>
      </mat-form-field>
      <mat-form-field appearance="outline" style="flex: 1" floatLabel="always">
        <mat-label>Created at</mat-label>
        <input matInput [value]="datePipe.transform(editForm.value.createdAtUtc, 'yyyy-MM-dd')" readonly style="cursor: default"/>
      </mat-form-field>
    </div>
    <div style="display: flex; gap: 10px;">
      <mat-form-field appearance="outline" style="flex: 1" floatLabel="always">
        <mat-label>Last modified by</mat-label>
        <input matInput [value]="editForm.value.changedByUser || ''" readonly style="cursor: default"/>
      </mat-form-field>
      <mat-form-field appearance="outline" style="flex: 1" floatLabel="always">
        <mat-label>Last modified at</mat-label>
        <input matInput [value]="datePipe.transform(editForm.value.changedAtUtc, 'yyyy-MM-dd')" readonly style="cursor: default"/>
      </mat-form-field>
    </div>
    <div style="display: flex;">
      <mat-form-field appearance="outline" style="width: 100%" floatLabel="always">
        <mat-label>File Path</mat-label>
        <input matInput [value]="editForm.value.selectedModelFilePath" readonly style="cursor: default"/>
      </mat-form-field>
    </div>
    <div style="display: flex;">
      <mat-form-field appearance="outline" style="width: 100%" floatLabel="always" class="editable-outline">
        <mat-label>Release name</mat-label>
        <input matInput formControlName="releaseName" />
      </mat-form-field>
    </div>
    <div style="display: flex;">
      <mat-form-field appearance="outline" style="width: 100%" floatLabel="always" class="editable-outline">
        <mat-label>Comment</mat-label>
        <input matInput formControlName="comment" />
      </mat-form-field>
    </div>
  }
  @if (data.isNew) {
    <h4 style="margin-bottom: 5px; margin-top: 0px;">Existing model file</h4>
    @if (data.isNew) {
      <div style="display: flex; gap: 10px;">
        <!-- Model File Dropdown - Select existing -->
        <div (click)="isNewFileActive() ? null : onModelFileFormFieldClick()" style="flex: 1" [style.cursor]="isNewFileActive() ? 'not-allowed' : 'pointer'">
          <mat-form-field appearance="outline"
            [ngClass]="{'editable-outline': data.isNew && !isNewFileActive(), 'disabled-outline': isNewFileActive()}"
            style="width: 100%">
            <mat-label>Select model file</mat-label>
            @if (data.isNew) {
              <button mat-icon-button matSuffix tabindex="-1" style="pointer-events: none;">
                <mat-icon [ngClass]="isNewFileActive() ? 'icon-color-fix-grey' : 'icon-color-fix-orange'">sync</mat-icon>
              </button>
            }
            <input type="text"
              matInput
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="selectedModelFileId"
              [matAutocomplete]="autoModelFile"
              (input)="onModelFileFilter($event)"
              [readonly]="!data.isNew || isNewFileActive()"
              [disabled]="isNewFileActive()" />
              <mat-autocomplete #autoModelFile="matAutocomplete"
                [displayWith]="getModelFileText.bind(this)"
                (optionSelected)="onModelFileSelected($event)">
                @for (file of filteredModelFiles; track file) {
                  <mat-option [value]="file.modelFileId">
                    {{ file.releaseName }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
      }
      <h4 style="margin-bottom: 5px; margin-top: 0px;">New model file</h4>
      <div style="display: flex; gap: 10px; align-items: stretch;">
        <!-- Upload New File -->
        <div (click)="selectedModelFileId > 0 ? null : fileInput.click()" style="flex: 1" [style.cursor]="selectedModelFileId > 0 ? 'not-allowed' : 'pointer'"
          [style.pointerEvents]="selectedModelFileId > 0 ? 'none' : 'auto'">
          <mat-form-field appearance="outline"
            [ngClass]="{'editable-outline': selectedModelFileId <= 0, 'disabled-outline': selectedModelFileId > 0}"
            style="width: 100%"
            floatLabel="always">
            <input matInput
              readonly
              [value]="editForm.value?.fileName || 'Upload file'" />
              <input #fileInput
                type="file"
                style="display: none"
                multiple
                [disabled]="selectedModelFileId > 0"
                (change)="onFileChange($event)" />
                <button mat-icon-button
                  matSuffix
                  [disabled]="selectedModelFileId > 0"
                  aria-label="Browse file">
                  <mat-icon matSuffix [ngClass]="selectedModelFileId > 0 ? 'icon-color-fix-grey' : 'icon-color-fix-orange'">search</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <!-- Release Name -->
            <div style="flex: 1" [style.pointerEvents]="selectedModelFileId > 0 ? 'none' : 'auto'">
              <mat-form-field appearance="outline"
                [ngClass]="{'editable-outline': selectedModelFileId <= 0, 'disabled-outline': selectedModelFileId > 0}"
                style="width: 100%">
                <mat-label>Release name</mat-label>
                <input matInput
                  formControlName="releaseName"
                  [readonly]="(!data.isNew && !editForm.value?.file) || selectedModelFileId > 0"
                  required />
                  @if (editForm.get('releaseName')?.hasError('required') && editForm.get('releaseName')?.touched) {
                    <mat-error>
                      Release name is required
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          }
          <mat-dialog-actions align="end" [style.justify-content]="!data.isNew ? 'space-between' : 'flex-end'">
            @if (data.isNew) {
              <button class="btn button-fix button-color-fix-red" mat-button (click)="onCancel()" cdkFocusInitial>Cancel</button>
            }
            @if (!data.isNew && editForm.value.modelFileId) {
              <button class="btn button-fix button-color-fix-orange"
                mat-button
                (click)="deleteModelFile()"
                [matTooltip]="'Delete Model File'">
                Delete
                <mat-icon style="color:white !important" class="icon-color-fix">delete</mat-icon>
              </button>
              <div style="margin-left: auto; display: flex; gap: 8px;">
                <button class="btn button-fix button-color-fix-red"
                  mat-button
                  (click)="downloadModelFile()"
                  [matTooltip]="'Download Model File'">
                  Download
                  <mat-icon style="color:white !important" class="icon-color-fix">download</mat-icon>
                </button>
                <button class="btn button-fix button-color-fix-orange"
                  mat-button
                  (click)="onSave()"
                  [disabled]="!hasReleaseNameChanged"
                  [matTooltip]="'Save Model File'">
                  Save
                  <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
                </button>
              </div>
            }
            @if (data.isNew) {
              <button class="btn button-fix button-color-fix-orange"
                mat-button
                (click)="onSave()"
                [matTooltip]="'Save Model File'">
                Save
                <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
              </button>
            }
          </mat-dialog-actions>
        </form>